import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import Header from '../../commons/Header/Header';
import './DeleteAccountPage.css';
import Translate from '../../../utils/Translate';
import DeleteAccountContainer from './DeleteAccountContainer';
import Alert from '../../commons/Alert/Alert';
import * as Pages from '../../../utils/Pages';

@withRouter
class DeleteAccountPage extends React.Component {
  constructor(props) {
    super(props);
    this.node = React.createRef();
  }

  render() {
    return (
      <div ref={(node) => { this.node = node; }} >
        <div className="eva-3-dashboard-aftersale DeleteAccountPage -eva-3-mb-xlg -eva-3-tc-gray-1 -eva-3-bc-gray-7">
          <Header
            name={Translate.message('Eliminar cuenta')}
            page={Pages.DELETE_ACCOUNT}
          />
          <div className="eva-3-container -eva-3-bc-gray-7 -p-0 -p-md-2 -pb-md-4 -pl-md-5 -pr-md-5 -pt-4">
            <div className="dashboard-aftersale-results-container eva-3-row -no-gutter">
              {
                this.props.isMerging &&
                <div className="col -sm-12 -lg-8 -eva-3-mb-lg">
                  <Alert type="warning" title={Translate.message('Estamos uniendo tus cuentas')}>
                    {Translate.message('Mientras se realiza el proceso, no podrás modificar los datos de tu perfil. Por favor, regresá más tarde.')}
                  </Alert>
                </div>
              }
              <div className="col -sm-12">
                <DeleteAccountContainer
                  isMerging={this.props.isMerging}
                  primaryEmail={this.props.primaryEmail}
                  loyalty={this.props.loyalty}
                  hasError={this.props.clustersErrors.personalInfo || (this.props.loyalty.isLoyalty && this.props.clustersErrors.loyalty)}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

DeleteAccountPage.propTypes = {
  isMerging: PropTypes.bool.isRequired,
  primaryEmail: PropTypes.string.isRequired,
  clustersErrors: PropTypes.shape().isRequired,
  loyalty: PropTypes.shape().isRequired,
};

export default DeleteAccountPage;
